import { create } from 'zustand';

interface TourState {
  startTour: (() => void) | null;
  registerTour: (start: (() => void) | null) => void;
}

export const useTourStore = create<TourState>((set) => ({
  startTour: null,
  registerTour: (start) => set({ startTour: start }),
}));
